import { Component } from "@angular/core";
import { ResetPasswordHintComponent } from "../reset-password-hint/reset-password-hint.component";

@Component({
  selector: "app-reset-password-hint-page",
  imports: [ResetPasswordHintComponent],
  templateUrl: "./reset-password-hint-page.component.html",
  styles: ``,
})
export class ResetPasswordHintPageComponent {}
